import React from 'react'

const SplashPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 dark:from-background-dark dark:to-surface-dark">
      <div className="flex flex-col items-center space-y-6 p-8">
        {/* Logo */}
        <div className="rounded-2xl bg-white px-5 py-4 shadow-2xl">
          <img src="/logo-leeris.png" alt="Leeris" className="h-10 w-auto" />
        </div>

        {/* App Name */}
        <div className="text-center">
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-1">
            Votre assurance santé
          </p>
        </div>

        {/* Loading indicator */}
        <div className="flex items-center space-x-2 mt-8">
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>

        {/* Version */}
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
          Version 1.0.0
        </p>
      </div>
    </div>
  )
}

export default SplashPage